module.exports = __webpack_public_path__ + "static/media/grin-beam.29f00a8e.svg";